import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BusinessStep from "../Wizard/steps/BusinessStep.jsx";

// Standalone single-step business editor for the "Businesses" dashboard
// page — reuses the wizard's BusinessStep as-is (same fields, validation,
// and save-to-backend logic). Cancel always returns to the Businesses list.
// Continue normally does too, unless we got here via the "New Filing" guard
// (goToNewFiling, newFiling.js) with no businesses on file yet - then
// location.state.returnTo sends the just-created business straight on into
// New Filing instead of dead-ending on a list of one.
const BusinessForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const returnTo = location.state?.returnTo;
  const backToList = () => navigate("/dashboard/businesses");
  const afterSave = () => navigate(returnTo || "/dashboard/businesses");

  return (
    <div className="max-w-[820px] mx-auto px-[22px] py-[26px] pb-[70px]">
      <BusinessStep onNext={afterSave} onBack={backToList} continueLabel="Save business →" backLabel="Cancel" />
    </div>
  );
};

export default BusinessForm;
